import { styled } from "@mui/material";

export const ContainerGrid = styled("div")(() => ({
  padding: "16px 32px",
}));
